import * as React from 'react';
import cn from '~modules/cn';
import Styles from './circle-loader.module.scss';

export type CircleLoaderColor = 'dark' | 'light' | 'positive';

type Props = {
    className?: string;
    type: 'sharp';
    subtype: 'full' | 'both-semi-1' | 'both-semi-2' | 'both-semi-3';
    color: CircleLoaderColor;
};

const CircleLoader = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        className={cn(props.className, Styles.svg, Styles[`type-${props.type}`], Styles[`subtype-${props.subtype}`], Styles[`color-${props.color}`])}
        ref={ref}
    >
        <circle cx="28" cy="28" r="24" strokeWidth="8" className={cn(Styles.circle, Styles['circle-bg'])} />
        <circle cx="28" cy="28" r="24" strokeWidth="8" className={cn(Styles.circle, Styles['circle-primary'])} />
    </svg>
));

CircleLoader.displayName = 'CircleLoader';

export default CircleLoader;
